import { useEffect, useState } from 'react';

import { secondsElapsed } from './stopwatch';

const TICK_MS = 250; // often enough for the second to change on every device together

/** The stopwatch, ticking: the whole seconds it shows. It only ticks while it runs */
const useStopwatch = (stopwatch) => {
  const [seconds, setSeconds] = useState(() => secondsElapsed(stopwatch));

  useEffect(() => {
    // The same value again does not render, so the board only redraws when a second goes by
    const tick = () => setSeconds(secondsElapsed(stopwatch));
    tick();
    if (!stopwatch?.running) return undefined;
    const interval = setInterval(tick, TICK_MS);
    return () => clearInterval(interval);
  }, [stopwatch]);

  return seconds;
};

export default useStopwatch;
